import React, {useEffect, useState} from "react"

import { Row, Col, Card, CardBody, Form, Label, FormGroup } from "reactstrap"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import "../PublicPromoCode/datatables.scss"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import _, { head } from 'lodash'
import Select from "react-select"
import Dropzone from "react-dropzone"
import {Link} from 'react-router-dom'
import SweetAlert from "react-bootstrap-sweetalert"
// MomentJS
import moment from 'moment'

const AddCarouselBanner = (props) => {
  const sections = [
    {value: "home", label: "Home", path: "frx-home"},
    {value: "payments", label: "Payments", path: "#"},
    {value: "rewards", label: "Rewards", path: "rewards"},
    {value: "makan_master", label: "Makan Master", path: "makan-master"},
    {value: "amperkz_transition", label: "AMPerkz Transition", path: ""},
    {value: "estore", label: "EStore", path: "estore"}
  ]
    const [token, setToken] = useState()
    const [selectedFiles, setselectedFiles] = useState([])
    const [selectedSection, setselectedSection] = useState(sections[0])
    const [selectedPosition, setselectedPosition] = useState({label: 1, value: 1})
    const [selectedStatus, setselectedStatus] = useState()
    const [neverEnding, setNeverEnding] = useState(false)
    const [success_msg, setsuccess_msg] = useState(false)
    const [errorMessage, SetErrorMessage] = useState('')
    const [errorMsgAlert, setErrorMsgAlert] = useState(false)
    // const [image_url, setImage_URL] = useState()

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
  }, [])

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }
  
  const sortOptions = [
    {value: 1, label: 1},
    {value: 2, label: 2},
    {value: 3, label: 3},
    {value: 4, label: 4},
    {value: 5, label: 5},
    {value: 6, label: 6},
    {value: 7, label: 7},
    {value: 8, label: 8},
    {value: 9, label: 9},
    {value: 10, label: 10}
  ]
  const statusOptions = [
    {value: "Y", label: "Enable"},
    {value: "N", label: "Disable"}
  ]
  
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success" 
        onConfirm={() => {
          props?.history.push(`/carousel-banners/${selectedSection?.path}`)
          setsuccess_msg(false)       
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {"Carousel Banner Added."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning        
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }
  function handleSubmit(){
    const name = document.getElementById("name_input").value;
    const section = selectedSection ? selectedSection.value : ""
    const position = selectedPosition?.label ? selectedPosition.label : ""
    const nav_to = document.getElementById("navigate_input").value;
    const publishAt = moment(document.getElementById("publishAt_input").value)?.format("YYYY/MM/DD HH:mm")
    const unpublishAt = moment(document.getElementById("unpublishAt_input").value)?.format("YYYY/MM/DD HH:mm");
    const version = document.getElementById("version_input").value;
    const status = selectedStatus ? selectedStatus.value : ""
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    currentDate = currentDate.toString()
    if(section == ''){
      alert("Page cannot be Empty")
      return
    }else if(selectedFiles.length < 1){
      alert("Please select image")
      return
    }else if(nav_to == ''){
      alert("Nav_to cannot be empty")
      return
    }else if(publishAt == ''){
      alert("Please select publish date")
      return
    }else if(unpublishAt == ''){
      alert("Please select unpublish date")
      return
    }else if(status == ''){
      alert("Please select status")
      return
    }else if(version == ''){
      alert("Please enter version")
      return
    }

    var myHeaders = new Headers();
    
    myHeaders.append("Authorization", "Bearer " + token);
    // myHeaders.append("Content-Type", "multipart/form-data;");
    myHeaders.append("cache-control", "no-cache");
    
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata = new FormData();
    formdata.append("path", "carousel/add");
    formdata.append("env", "staging");
    // formdata.append("description", "Test Desc");
    // formdata.append("announcement_status", "test");
    formdata.append("created_datetime", currentDate);
    formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    formdata.append("item_status", status);
    formdata.append("item_type", "\"carousel_banner\"");
    formdata.append("item_version", version);
    formdata.append("navigate_to", nav_to);
    formdata.append("page", section);
    formdata.append("published_at", publishAt);
    formdata.append("unpublished_at", neverEnding ? null : unpublishAt);
    formdata.append("slider_delay", "0");
    formdata.append("sort_order", position);
    formdata.append("api", true);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result){          
          if(result?.Items?.length > 0){
            setsuccess_msg(true)
          }
        }else{
          SetErrorMessage("Unable to Add Carousel Banner")
          setErrorMsgAlert(true)
        }
      })
      .catch(error => console.log('error', error));
    
  }

  const validateFileSize = (file) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;

        if (width !== 1200 || height !== 500) {
          SetErrorMessage("Height and Width must be 1200x500px")
          setErrorMsgAlert(true)
          // alert("Height and Width must be 600px.");
          return false;
        }
        // alert("Uploaded image has valid Height and Width.");
        handleAcceptedFiles(file)
        return true;
      };
    };
  }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Carousel Banners" breadcrumbItem="Add Carousel Banner" />

          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form 
                        className=""
                        method="post"
                        id="tooltipForm">
                          <div>
                            <Row className="mb-3">
                                <Label className="col-sm-8 col-form-label" htmlFor="formrow-firstname-input">Name</Label>
                                <div className="col-md-10">
                                <input
                                    className="form-control"
                                    type="text"
                                    defaultValue=""
                                    id="name_input"
                                />
                                </div>
                            </Row>
                            
                          <Row>
                              <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Section</Label>
                              <Select
                                isSearchable={false}
                                value={selectedSection}
                                onChange={(e) => {
                                  setselectedSection(e)
                                }}
                                placeholder={selectedSection ? selectedSection.label : "Choose section..."}
                                defaultValue={sections[0]}
                                options={sections}
                                required
                              />
                            </div>
                              </Col>
                            {/* <Col lg={1}></Col> */}
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <Select
                                isSearchable={false}
                                placeholder={"Choose..."}
                                options={sortOptions}
                                value={selectedPosition}
                                onChange={(e) => {
                                  setselectedPosition(e)
                                }}
                                placeholder={selectedPosition ? selectedPosition.label : "Choose..."}
                                defaultValue={sortOptions[0]}
                                required
                              />
                            </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                                <Label className="col-sm-8 col-form-label" htmlFor="formrow-firstname-input">Navigate To</Label>
                                <div className="col-md-10">
                                <input
                                    className="form-control"
                                    type="text"
                                    defaultValue=""
                                    id="navigate_input"
                                />
                                </div>
                         </Row>                          
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
              <CardBody>
                  <Form>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        validateFileSize(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted uil uil-cloud-upload"/>
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                            <p style={{fontSize: 12, color: "red"}}>Image should be 1200x500px,  jpg or png</p>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                  </Form>

                  {/* <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Send Files
                    </button>
                  </div> */}
                </CardBody>
              </Card>
              <Card>
                  <CardBody>
                  <Row>
                              <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  id="publishAt_input"
                              />
                            </div>
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  id="unpublishAt_input"
                                  disabled={neverEnding}
                              />
                            </div>
                            </div>
                            </Col>
                            <Col style={{paddingTop: 35}}>
                                <div className="form-check form-switch">
                                    <input
                                        type="checkbox"
                                        className="form-check-input checkbox"
                                        id="checkbox_1"
                                        value={neverEnding}
                                        defaultChecked={neverEnding}
                                        onChange={()=>{setNeverEnding(!neverEnding)}}
                                    />

                                    <label className="form-check-label" htmlFor="checkbox_1">
                                        Never-ending
                                    </label>
                                </div>
                            </Col>
                          </Row>
                  </CardBody>
              </Card>
              <Card>
                  <CardBody>
                  <Row>
                              <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                value={selectedStatus}
                                onChange={(e) => {
                                  setselectedStatus(e)
                                }}
                                options={statusOptions}
                                placeholder={selectedStatus ? selectedStatus.label : "Choose..."}
                                defaultValue={statusOptions[0].label}
                                required
                              />
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Version</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="version_input"
                              />
                            </div>
                            </div>
                            </Col>
                          </Row>
                  </CardBody>
              </Card>
              {success_msg ? (
                            renderSuccessAlert()
                          ) 
                          :
                          null 
                          }
                          {errorMsgAlert ? (
                            renderFailureAlert()
                          )
                          :
                          null
                          }
              <Row>
                  <Col></Col>
                  <Col>
                  <div className="d-print-none mt-4">
                        <div className="float-end" style={{marginBottom: 20}}>
                        <div onClick={()=>{
                          props?.history?.goBack()
                        }} className="btn btn-danger"> <i className="uil uil-times me-1"></i> Cancel </div>{" "}
                          <div onClick={()=>{
                          handleSubmit()
                        }} className="btn btn-success w-md waves-effect waves-light">Save</div>
                        </div>
                </div>
                  </Col>
                  <Col lg={3}></Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddCarouselBanner;
